import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/layout/index.vue';

Vue.use(Router);

const menuRoute = [{
  path: '/report',
  component: Layout,
  name: '交易报表',
  redirect: '/report/detail',
  children: [{
    path: 'detail',
    name: 'report',
    component: () => import('@/views/report/index'),
    meta: { title: '交易报表', icon: 'iconcebianlanicon-1' },
  }],
},
{
  path: '/flow',
  component: Layout,
  name: '交易流水',
  children: [{
    path: 'detail',
    name: 'flow',
    component: () => import('@/views/flow/index'),
    meta: { title: '交易流水', icon: 'iconcebianlanicon-' },
  }],
},

{
  path: '/account',
  component: Layout,
  name: '对账管理',
  children: [{
    path: 'detail',
    name: 'account',
    component: () => import('@/views/account/index'),
    meta: { title: '对账管理', icon: 'iconcebianlanicon-3' },
  }],
},
{
  path: '/device-manage',
  component: Layout,
  name: '设备管理',
  children: [{
    path: 'detail',
    name: 'device-manage',
    component: () => import('@/views/device-manage/index'),
    meta: { title: '设备管理', icon: 'icon-shebeiguanli' },
  }],
},
{
  path: '/member-permisson',
  component: Layout,
  name: '成员与权限',
  meta: { title: '成员与权限', icon: 'icon-quanxian' },
  children: [{
    path: 'detail',
    name: 'member-permisson',
    component: () => import('@/views/member-permisson/index'),
    meta: { title: '成员与权限', icon: 'icon-quanxian', activeMenu: '/member-permisson/detail' },
  },
  {
    path: 'modifyInfo',
    name: 'modify-info',
    component: () => import('@/views/member-permisson/modify-info'),
    meta: { title: '编辑成员信息与权限', icon: 'iconcebianlanicon-4', activeMenu: '/member-permisson/detail' },
    hidden: true,
  },
  ],
},
{
  path: '/merchant-info',
  component: Layout,
  name: '商户信息',
  children: [{
    path: 'detail',
    name: 'merchant-info',
    component: () => import('@/views/merchant-info/index'),
    meta: { title: '商户信息', icon: 'iconcebianlanicon-2' },
  },
  {
    path: 'modifyInfo',
    name: 'view-info',
    component: () => import('@/views/merchant-info/view-info'),
    meta: { title: '商户基本信息', icon: 'iconcebianlanicon-4', activeMenu: '/merchant-info/detail' },
    hidden: true,
  }],
},
{
  path: '/data-report',
  component: Layout,
  name: '数据报表',
  children: [{
    path: 'detail',
    name: 'data-report',
    component: () => import('@/views/data-report/index'),
    meta: { title: '数据看板', icon: 'iconcebianlanicon-1' },
  }],
},
{
  path: '/settle',
  component: Layout,
  name: '结算',
  children: [{
    path: 'detail',
    name: 'settle-list',
    component: () => import('@/views/settle-manage/index'),
    meta: { title: '结算管理', icon: 'iconcebianlanicon-3' },
  }],
},
{
  path: '/income',
  component: Layout,
  name: '收益',
  meta: { title: '收益管理', icon: 'iconcebianlanicon-3' },
  children: [{
    path: '/income-detail',
    name: 'income-detail',
    component: () => import('@/views/income/detail'),
    meta: { title: '收益明细', icon: 'iconcebianlanicon-' },
  },
  {
    path: '/income-draw',
    name: 'income-draw',
    component: () => import('@/views/income/crash'),
    meta: { title: '收益提现', icon: 'iconcebianlanicon-3' },
  },
  {
    path: '/income-withdraw',
    name: 'income-withdraw',
    component: () => import('@/views/income/withdraw'),
    // meta: { title: '提现新增', icon: 'iconcebianlanicon-3' },
  }],
},
];


export const constantRoutes = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true,
},

{
  path: '/forgetPwd',
  component: () => import('@/views/forgetPwd/index'),
  hidden: true,
},
{
  path: '/modifyPwd',
  component: () => import('@/views/modifyPwd/index'),
  hidden: true,
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true,
},
{
  path: '/',
  component: Layout,
  redirect: '/report',
},

// {
//   path: '/',
//   component: Layout,
//   redirect: '/index',
//   children: [{
//     path: 'index',
//     component: () => import('@/views/index/index'),
//   }],
// },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

export const menuRouteArr = [
  ...menuRoute,
  // // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
